// Centralised test IDs — used across the app for reliable QA automation.
export const NAV = {
  logo: "nav-logo",
  linkHome: "nav-link-home",
  linkServices: "nav-link-services",
  linkCaseStudies: "nav-link-case-studies",
  linkAbout: "nav-link-about",
  linkBlog: "nav-link-blog",
  linkContact: "nav-link-contact",
  ctaStart: "nav-cta-start",
  mobileToggle: "nav-mobile-toggle",
  mobileMenu: "nav-mobile-menu",
};

export const HOME = {
  heroCta: "home-hero-cta",
  heroSecondary: "home-hero-secondary",
  servicePrefix: "home-service-card",
  serviceLearnMorePrefix: "home-service-learn-more",
  finalCta: "home-final-cta",
};

export const SERVICES_PAGE = {
  cardPrefix: "service-card",
  learnMorePrefix: "service-learn-more",
};

export const CONTACT = {
  form: "contact-form",
  inputName: "contact-input-name",
  inputEmail: "contact-input-email",
  inputCompany: "contact-input-company",
  inputPhone: "contact-input-phone",
  inputInterest: "contact-input-interest",
  inputMessage: "contact-input-message",
  submit: "contact-submit",
  success: "contact-success",
  error: "contact-error",
  mailto: "contact-mailto",
};

export const CASE_STUDIES_PAGE = {
  cardPrefix: "case-study-card",
};

export const BLOG_PAGE = {
  cardPrefix: "blog-card",
};
